
// Get AWS configuration from environment variables
const awsmobile = {
  "aws_project_region": import.meta.env.VITE_AWS_REGION || "us-east-1",
};

export default awsmobile;
